import { NextPage } from "next";

import { PillarGenericPage } from "~/components/pillar-generic-page";

import EvolutionLifeCycleLogo from "../../../public/evolution_lifecycle.png";

const DigitalBluePrintPage: NextPage = () => (
  <PillarGenericPage
    title="Clareza na tomada de decisão"
    description="Evolution Lifecycle"
    subdescription="Em meio a tantas novidades tecnológicas e práticas de mercado, entenda o que realmente é realmente agrega valor na jornada da sua empresa."
    image={EvolutionLifeCycleLogo}
    paragraphs={[
      {
        main: "Tendências",
        content:
          "Peneirar entre um mundo de tendências e focar na implantação correta com um desenho de estratégia que ajude seu negócio a ser potencializado com o que há de novo no mercado é um desafio que as empresas enfrentam no dia a dia. Auxiliar nesse momento e garantir os KPIs de sucesso fazem parte de nosso DNA.",
      },
      {
        main: "Novos Modelos de Negócio",
        content:
          "Investir em Novos Canais e Modelos de Negócio. Somos desafiados constantemente em nossas empresas a abraçar as oportunidades, mas como tirar o maior proveito desses caminhos de maneira eficiente é nosso foco constante.",
      },
      {
        main: "Soluções",
        content:
          "Novas soluções, plataformas, ferramentas. Conhecemos, testamos e conhecemos a fundo os diferenciais de cada ferramenta na prática e ajudamos a desenhar o stack perfeito de solução para seu negócio.",
      },
      {
        main: "Business Cases",
        content:
          "Na maioria das vezes o desenho correto do business case é o maior gargalo para permitir e dar consistência aos projetos de inovação e evolução da jornada digital. Identificar e construir o modelo correto é essencial para garantir o sucesso do projeto.",
      },
    ]}
  />
);
export default DigitalBluePrintPage;
